// PRODUCTION — drop target after the last step in a group during drag-and-drop
import React from 'react'
import tw from 'twin.macro'
import type { FlowEditorStepDropTarget } from 'src/utils/collectDataTemplateEditor/stepReorder'
import { FlowEditorStepDropIndicator } from './FlowEditorStepDropIndicator'

interface Props {
  configId: string
  draggedStepId: string | null
  groupStepCount: number
  handleDragEnd: () => void
  handleDragOver: (event: React.DragEvent, dropTarget: FlowEditorStepDropTarget) => void
  handleDrop: (dropTarget: FlowEditorStepDropTarget) => void
  isDropTarget: (dropTarget: FlowEditorStepDropTarget) => boolean
}

export function FlowEditorStepGroupTrailingDropTarget({
  configId,
  draggedStepId,
  groupStepCount,
  handleDragEnd,
  handleDragOver,
  handleDrop,
  isDropTarget,
}: Props) {
  if (draggedStepId === null || groupStepCount === 0) {
    return null
  }

  const dropTarget: FlowEditorStepDropTarget = {
    configId,
    indexInGroup: groupStepCount,
  }
  const highlighted = isDropTarget(dropTarget)

  return (
    <div
      onDragOver={(event) => {
        handleDragOver(event, dropTarget)
      }}
      onDrop={() => {
        handleDrop(dropTarget)
      }}
      onDragEnd={handleDragEnd}
      css={tw`min-h-[12px]`}
    >
      {highlighted ? <FlowEditorStepDropIndicator /> : null}
    </div>
  )
}
